import {
  CATEGORY_PAGE_FILTERING,
  CLEAR_EVENT_DATE,
  CLOSE_EVENT_FILTER_DROPDOWN,
  CLOSE_FILTER_MODAL,
  CLOSE_PARTY_FILTER_DROPDOWN,
  DISABLE_HTO_FILTER,
  ENABLE_EVENT_DATE_FILTER,
  ENABLE_GROUP_PARTY_FILTER,
  ENABLE_HTO_FILTER,
  ENABLE_INDIVIDUAL_PARTY_FILTER,
  FILTER_BY_BUY_ONLY,
  FILTER_SUCCESS,
  OPEN_EVENT_FILTER_DROPDOWN,
  OPEN_FILTER_MODAL,
  OPEN_PARTY_FILTER_DROPDOWN,
  RESET_ALL_FILTERS,
  SELECT_EVENT_DATE,
  SELECT_PARTY_RADIO_GROUP,
  SELECT_PARTY_RADIO_INDIVIDUAL,
  TOGGLE_HTO_FILTER,
} from '../actions/productCategoryPage'

import {
  CATEGORY_NOT_OK,
  CATEGORY_OK,
  DISPLAY_CATEGORY,
  RESET_TO_INITIAL_STATE,
} from '../actions/product'

const initialState = {
  categoriesBySlug: {},
  currentPartyFilter: 'Individual',
  displayedCategory: null,
  displayedCategoryBySlug: null,
  enableEventDateFilter: false,
  enableGroupFilter: false,
  enableHtoFilter: false,
  enableIndividualFilter: true,
  eventFilterDropdownIsOpen: false,
  eventFilterIsTouched: false,
  filteredCategoryItems: [],
  filterModalIsOpen: false,
  isFiltering: false,
  partyFilterDropdownIsOpen: false,
  partyFilterIsTouched: false,
  selectedPartyFilter: 'Individual',
  isFilterByBuyActive: false,
}

export default function reducer(state = initialState, action) {
  let newState
  switch (action.type) {
    case RESET_TO_INITIAL_STATE:
      newState = initialState
      break

    case ENABLE_EVENT_DATE_FILTER:
      newState = {
        currentEventDateFilter: state.selectedEventDate,
        enableEventDateFilter: true,
        eventFilterDropdownIsOpen: false,
        eventFilterIsTouched: true,
      }
      break

    case CLEAR_EVENT_DATE:
      newState = {
        currentEventDateFilter: undefined,
        enableEventDateFilter: false,
        eventFilterDropdownIsOpen: false,
        eventFilterIsTouched: false,
        selectedEventDate: undefined,
      }
      break

    case SELECT_EVENT_DATE:
      newState = {selectedEventDate: action.payload}
      break

    case OPEN_EVENT_FILTER_DROPDOWN:
      newState = {eventFilterDropdownIsOpen: true}
      break

    case CLOSE_EVENT_FILTER_DROPDOWN:
      newState = {
        eventFilterDropdownIsOpen: false,
        selectedEventDate: state.currentEventDateFilter,
      }
      break

    case SELECT_PARTY_RADIO_GROUP:
      newState = {selectedPartyFilter: 'Group'}
      break

    case SELECT_PARTY_RADIO_INDIVIDUAL:
      newState = {selectedPartyFilter: 'Individual'}
      break

    case DISPLAY_CATEGORY:
      newState = {displayedCategoryBySlug: action.data}
      break

    case CATEGORY_NOT_OK: {
      const newCategoriesBySlug = Object.assign({}, state.categoriesBySlug, {
        [action.data]: false,
      })
      // add newly discovered products to productsBySlug
      newState = Object.assign({}, state, {
        categoriesBySlug: newCategoriesBySlug,
      })
      newState.displayedCategory = newState.categoriesBySlug[state.displayedCategoryBySlug]
      break
    }

    case CATEGORY_OK: {
      const newCategoriesBySlug = Object.assign({}, state.categoriesBySlug, {
        [action.data.slug]: {...action.data, status: 'OK'},
      })
      // add newly discovered products to productsBySlug
      newState = Object.assign({}, state, {
        categoriesBySlug: newCategoriesBySlug,
      })
      newState.displayedCategory = newState.categoriesBySlug[state.displayedCategoryBySlug]
      // Hide non-rentable items from PCP page since Jacuzzi PCP's are still
      // currently accessed by the add items flow
      newState.filteredCategoryItems = newState.displayedCategory.display_items.filter(
        (item) => item.product_set.is_rentable,
      )

      break
    }

    case FILTER_SUCCESS:
      newState = {
        // Hide non-rentable items from PCP page since Jacuzzi PCP's are still
        // currently accessed by the add items flow
        filteredCategoryItems: action.payload.filter((item) => item.product_set.is_rentable),
        isFiltering: false,
      }
      break

    case ENABLE_HTO_FILTER: {
      newState = {enableHtoFilter: true}
      break
    }

    case DISABLE_HTO_FILTER: {
      newState = {enableHtoFilter: false}
      break
    }

    case TOGGLE_HTO_FILTER: {
      newState = {enableHtoFilter: !state.enableHtoFilter}
      break
    }

    case ENABLE_GROUP_PARTY_FILTER:
      newState = {
        enableIndividualFilter: false,
        enableGroupFilter: true,
        currentPartyFilter: 'Group',
        partyFilterDropdownIsOpen: false,
        partyFilterIsTouched: true,
      }
      break

    case ENABLE_INDIVIDUAL_PARTY_FILTER:
      newState = {
        enableIndividualFilter: true,
        enableGroupFilter: false,
        currentPartyFilter: 'Individual',
        partyFilterDropdownIsOpen: false,
        partyFilterIsTouched: true,
      }
      break

    case OPEN_PARTY_FILTER_DROPDOWN:
      newState = {partyFilterDropdownIsOpen: true}
      break

    case CLOSE_PARTY_FILTER_DROPDOWN:
      newState = {
        partyFilterDropdownIsOpen: false,
        selectedPartyFilter: state.currentPartyFilter,
      }
      break

    case CATEGORY_PAGE_FILTERING:
      newState = {isFiltering: true}
      break

    case OPEN_FILTER_MODAL:
      newState = {filterModalIsOpen: true}
      break

    case CLOSE_FILTER_MODAL:
      newState = {filterModalIsOpen: false}
      break
    case FILTER_BY_BUY_ONLY:
      newState = {isFilterByBuyActive: true}
      break
    case RESET_ALL_FILTERS:
      newState = {
        enableGroupFilter: false,
        enableIndividualFilter: true,
        currentEventDateFilter: undefined,
        currentPartyFilter: 'Individual',
        eventFilterIsTouched: false,
        partyFilterIsTouched: false,
        selectedEventDate: undefined,
        selectedPartyFilter: 'Individual',
        isFilterByBuyActive: false,
      }
      break

    default:
      break
  }

  return newState ? Object.assign({}, state, newState) : state
}
